import { PublicLayout, MainLayout } from 'layouts';
import { Login, Home, PaperworkEntryListPage, PaperworkEntryDetailPage, PaperworkEntryImageEditPage, PaperworkEntryPrint, PrivacyPolicy, PaperworkEntryEditPage } from 'pages';
import * as React from 'react';
import { Redirect } from 'react-router-dom';
import { LoggedInWrap, AdminWrap, NavigateToMainWrap, NavigateToPrivacyPolicy } from 'routing';


function InvalidUrl() {
    return ( 
        <Redirect to='' />
    )
}

const routes = [
    {
        path: '/',
        component: LoggedInWrap(AdminWrap(MainLayout)),
        index: {
            component: Home
        },
        routes: [
            {
                path: '',
                component: Home
            },
            {
                path: 'paperworks',
                component: PaperworkEntryListPage
            },
            {
                path: 'paperworks/:id',
                component: PaperworkEntryDetailPage
            },
            {
                path: 'print',
                component: PaperworkEntryPrint
            },
            {
                path: 'paperwork/image/:id',
                component: PaperworkEntryImageEditPage
            },
        ]
    }, 
    {
        component: PublicLayout,
        routes: [
            {
                path: '/login',
                component: NavigateToMainWrap(Login)
            },
            {
                path: '/PrivacyPolicy',
                component: PrivacyPolicy
            },       
            {
                component: InvalidUrl
            },
        ]
    }
];

export { routes };



// WEBPACK FOOTER //
// ./src/routing/routes.js